<app-backgrop>
  <div class="w-full max-w-[1200px]  pt-16 p-6 sm:p-8 md:p-16 flex min-h-full">
    <div class="max-h-9/10 w-full flex flex-col items-center justify-between">
      <div
        class=" uppercase bg-black/50 px-8 py-4 font-bold text-white text-base/[110%] md:text-4xl/[110%] rounded-lg mb-6 shrink-0"
      >
        Выбери персонажа:
      </div>

      <!-- Обертка, чтобы центрировать двух персонажей -->
      <div class="grid grid-cols-2 w-full h-[50dvh]  grow-1">
        <!-- Мальчик -->
        <div class="flex justify-center">
          <div class="custom-img-container male relative w-[126px] md:w-fit  flex items-end justify-center px-1 md:px-10 py-5 cursor-pointer pb-0 after:content-[''] after:absolute after:inset-0 after:bg-gradient-to-t after:from-white after:to-transparent after:opacity-0
                  hover:after:opacity-50 after:transition-opacity after:duration-300"
                  [class.after:opacity-100]="selectedGender === 'male'"
                  [class.hover:after:opacity-100]="selectedGender === 'male'"
                  (pointerover)="playHover()"
                  (click)="playClick(); choose('male')">
              <img class="pointer-events-none select-none  absolute left-0 bottom-0 w-full z-99 transform translate-y-1/2" src="./assets-compressed/images/gender/podium.png" alt="">
            <picture class="pointer-events-none">
              <source srcset="./assets-compressed/images/gender/boy.webp" type="image/webp">
              <img src="./assets-compressed/images/gender/boy.png" alt="" class="custom-img select-none  h-[50dvh] max-h-full object-contain scale-x-[-1] relative z-100">
            </picture>
          </div>
        </div>

        <!-- Девочка -->
        <div class="flex justify-center">
          <div
            class="custom-img-container female relative w-[126px] md:w-fit flex items-end justify-center px-1 md:px-10 py-5 pb-0 cursor-pointer
                  after:content-[''] after:absolute after:inset-0 after:bg-gradient-to-t after:from-white after:to-transparent after:opacity-0
                  hover:after:opacity-50 after:transition-opacity after:duration-300"
                  [class.after:opacity-100]="selectedGender === 'female'"
                  [class.hover:after:opacity-100]="selectedGender === 'female'"
                  (pointerover)="playHover()"
                  (click)="playClick(); choose('female')"
          >
              <img class="pointer-events-none select-none absolute left-0 bottom-0 w-full z-99 transform translate-y-1/2" src="./assets-compressed/images/gender/podium.png" alt="">
            <picture class="pointer-events-none">
              <source srcset="./assets-compressed/images/gender/girl.webp" type="image/webp">
              <img src="./assets-compressed/images/gender/girl.png" alt="" class="custom-img select-none  h-[50dvh] max-h-full object-contain relative z-100">
            </picture>
          </div>
        </div>

      </div>
      <app-button class="custom-button bottom-7 md:static mt-24" [disabled]="!selectedGender" (clicked)="select()">
        Продолжить
      </app-button>

    </div>
  </div>
</app-backgrop>
